<template>
	<div class="cabinet-login-header">
		<div class="logo">
			<a v-if="!isMobile" :href="homeUrl" target="_blank">
				<img
					src="/assets/images/logo_tradeview_white.svg"
					alt="logo tvmarkets"
				/>
			</a>
			<a v-else :href="homeUrl" target="_blank">
				<img
					src="/assets/images/logo_tradeview_white_mobile.svg"
					alt="logo tvmarkets"
				/>
			</a>
		</div>
		<div class="options">
			<div v-if="actualLanguage === 'jp'">
				<TVButtonBase
					:value="$t('loginHeader.contactUs')"
					variant="primary"
					size="sm"
					type="button"
					class="sm:w-auto"
					@click="openLink"
				/>
			</div>
			<div v-else>
				<a :href="contactUrl" target="_blank" class="links">
					{{ $t('loginHeader.contactUs') }}
				</a>
			</div>

			<div class="contact-icon">
				<a :href="contactUrl" target="_blank">
					<span class="material-symbols-outlined" translate="no">
						contact_support
					</span>
				</a>
			</div>
			<div class="options-container">
				<!-- select language mobile-->
				<SelectLanguageMobile
					class="mobile-language-flag"
					:language="language"
					@click="showLanguageMobileModal"
				/>
				<!-- select language desktop-->
				<SelectLanguage
					class="cabinet-login-language"
					v-model="language"
					@click="showLanguageMobileModal"
				/>
			</div>
		</div>
	</div>
	<ModalLanguageMobile
		:isOpen="showModalLanguageMobile"
		@close="showModalLanguageMobile = false"
		@language-changed="changeLocale"
	/>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import SelectLanguage from '@/components/SelectLanguage'
import SelectLanguageMobile from '@/components/SelectLanguageMobile'
import ModalLanguageMobile from '@/components/cabinet/ModalLanguageMobile'
import { getLanguageArabic } from '@/_helpers/stylesArabic.js'
import TVButtonBase from '../../../modules/ui/TVButtonBase.vue'
const language = ref('en')
const showModalLanguageMobile = ref(false)
const isMobile = ref(window.innerWidth <= 768)
const isLanguageArabic = ref(getLanguageArabic())
const actualLanguage = ref(null)

const showLanguageMobileModal = () => {
	showModalLanguageMobile.value = true
}

const checkMobile = () => {
	isMobile.value = window.innerWidth <= 768
}

const contactUrl = computed(() => {
	const lang = actualLanguage.value === 'pt' ? 'pt-br' : actualLanguage.value

	if (isLanguageArabic.value) {
		return 'https://www.tradeviewmena.com/contact/'
	}

	if (actualLanguage.value === 'jp') {
		return 'https://www.tvmarkets.com/ja'
	}

	return `https://www.tvmarkets.com/${lang}/contact-us/`
})

const openLink = () => {
	window.open(contactUrl.value, '_blank')
}

const homeUrl = computed(() => {
	return isLanguageArabic.value
		? 'https://www.tradeviewmena.com'
		: 'https://www.tvmarkets.com'
})

onMounted(() => {
	window.addEventListener('resize', checkMobile)
	checkMobile()
	actualLanguage.value = localStorage.getItem('language')
})
</script>
